import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor () { }
  public baseUrl = environment.baseUrl;

  timeAgo (dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
      second: 1
    };

    for (let [unit, value] of Object.entries(intervals)) {
      const elapsed = Math.floor(seconds / value);
      if (elapsed >= 1) {
        return `${elapsed} ${unit}${elapsed > 1 ? 's' : ''} ago`;
      }
    }
    return 'just now';
  }


  defaultChartOptions = {
    responsive: true,
    legend: {
      display: false
    },
    scales: {
      yAxes: [
        {
          // scaleLabel: {
          //   labelString: `Amount ${String.fromCharCode(0x20a6)}`,
          //   display: true
          // },
          display: true,
          gridLines: {
            display: true,
            drawBorder: false,
            borderDash: [3],
          },
          ticks: {
            suggestedMin: 3,
            padding: 10,
            fontColor: '#5C6370',
            // callback: (value: number, index, values) => {
            //   if (Number(value) >= 1000000000000) {
            //     return (value / 1000000000000) + 't'
            //   } else if (Number(value) >= 1000000000) {
            //     return (value / 1000000000) + 'b'
            //   } else if (Number(value) >= 1000000) {
            //     return (value / 1000000) + 'm'
            //   } else if (Number(value) >= 1000) {
            //     return (value / 1000) + 'k'
            //   } else {
            //     return value
            //   }
            // },
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
    maintainAspectRatio: false,
    tooltips: {
      // callbacks: {
      //   label: function (tooltipItem, data) {
      //     return data.datasets[tooltipItem.datasetIndex].label + ': ' + String.fromCharCode(0x20A6) + tooltipItem.yLabel.toLocaleString();
      //   }
      // }

    }
  }

  private cache$: { [key: string]: Observable<any> } = {};
  public getCache (key: string): Observable<any> | null {
    return this.cache$[key] || null;
  }
  public setCache (key: string, value: Observable<any>): void {
    this.cache$[key] = value;
  }
  public clearCache (key: any): void {
    delete this.cache$[JSON.stringify(key)];
  }
  public clearAllCache (): void {
    this.cache$ = {};
  }
  requestWithCache (obs: Observable<any>, reqData) {
    const cacheKey = JSON.stringify(reqData);
    if (!this.getCache(cacheKey)) {
      const response$ = obs.pipe(shareReplay(1));
      this.setCache(cacheKey, response$);
      return response$;
    } else {
      return this.getCache(cacheKey);
    }
  }

  throttle (fn: Function, limit: number) {
    let lastFunc: NodeJS.Timeout;
    let lastRan: number;
    return (...args: any[]) => {
      if (!lastRan) {
        fn(...args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if ((Date.now() - lastRan) >= limit) {
            fn(...args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  };
}
